module.exports = __webpack_public_path__ + "static/media/2.52831a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/2.png
// module id = 220
// module chunks = 0